/* global google */

import { MAP_SELECTION_CONTAINER } from './../../../../constants/strings/StringsDashboard';

import { srcCorregimientos, srcVeredas, center } from './../../../../constants/services/map'
import { sendService, answerOk, makeId } from '../../../../Services/service'
// import { Polygon } from 'recharts';


var map, heatmap;
var markers = [];
var Popup, popupOld;

var polyCroquis, polyCapa
var capaActual;
var mapaActual = [{ object: 'inicio', id: 0 }]

var streets;
var satellite = false;
var layers = [];
var funcFromMap;
var indexActions;
var pointMarkersOnMap = [];
var addedPoint;
var addedMarker;
var grupo;
var addingPoint = false;
var resizeObserver;
var divMap;
var onAddedPoint;
var intensity = 0;
var radius = 0;
var opacity = 60;
var openHeatAdjustment = false;
var creatingPolys = false;
var addPointListener;
// var addPolygonListener;
var softPolygons = new Map();
// var hardPolygons = new Map();
var plotedPolygons = new Map();
var actualPoly = makeId(8);
var polyMarkers = [];
var editPointMarker;
var actionPosEditPoin = -1;
var actionSetEditPoin = 2;
var addedPointMarker;
// var sendPolygon;
var mapStep = 0
var comunaSelected = ''

softPolygons.set(actualPoly, []);

const initMap = (opts) => {
  const divMap = document.getElementById('map');
  map = new google.maps.Map(divMap, {
    center,
    zoom: 12,
    disableDefaultUI: true,
    // scrollwheel: false,
    styles: styleRoad
  });

  divMap.addEventListener('mousewheel', (e) => {

    // const zoom = map.getZoom();
    // const newZoom = zoom - (e.deltaY * 0.005);
    // console.log(zoom, e.deltaY, e.deltaY * 0.005, newZoom);
    // map.setZoom(newZoom);
    // console.log(map.getZoom());
    // // if(e.deltaY === -100){
    // // }else if(e.deltaY === 100){

    // // }
  });

  HttpServiceCroquis(srcCorregimientos);
  HttpServiceCapa(srcVeredas);

  funcFromMap = opts.fromMap;
  indexActions = opts.indexActions;
  // sendPolygon = opts.sendPolygon;

  let divAdmin = document.createElement('div');
  divAdmin.classList.add('globo-mapa');
  divAdmin.classList.add('top-left');
  let labelTitle = document.createElement('label')
  labelTitle.classList.add('color-white')
  labelTitle.innerText = 'Polígono: '
  divAdmin.appendChild(labelTitle)
  let spanMun = document.createElement('span')
  spanMun.classList.add('color-white')
  spanMun.id = 'mpio-text'
  divAdmin.appendChild(spanMun)
  let paraf = document.createElement('p');
  paraf.id = 'mouse-over';
  paraf.classList.add('popup-bundle-title');
  divAdmin.appendChild(paraf);

  createDivLayer(true, ['fas', 'fa-cog', 'loading', 'open-close-legend', 'layers-icon-style'], 'Cargando');

  // const divCreatePolygon = createDivPolys();

  let divRseult = document.createElement('div');
  ['globo-mapa', 'bottom-rigth'].forEach(c => divRseult.classList.add(c));
  divRseult.appendChild(createCheckboxMap(MAP_SELECTION_CONTAINER.CASES, false, 'casos', 0, () => {
    if (document.getElementById('casos').checked) showMarkers();
    else hideMarkers();
  })
  );
  divRseult.appendChild(document.createElement('br'));
  divRseult.appendChild(createCheckboxMap(MAP_SELECTION_CONTAINER.HEAT, false, 'calor', 0, () => {
    if (document.getElementById('calor').checked) showHeat();
    else hideHeat();
  })
  );
  divRseult.appendChild(document.createElement('hr'));
  divRseult.appendChild(createCheckboxMap('Fijar escala calor', false, 'fix', 0, () => {
    if (document.getElementById('fix').checked) {
      const zoom = map.getZoom()
      map.addListener("zoom_changed", () => {
        switch (map.getZoom() - zoom) {
          case 8: heatmap.set("radius", (radius * 256) - (256 * 4)); break;
          case 7: heatmap.set("radius", (radius * 128) - (128 * 2)); break;
          case 6: heatmap.set("radius", (radius * 64) - (64 * 2)); break;
          case 5: heatmap.set("radius", radius * 32); break;
          case 4: heatmap.set("radius", radius * 16); break;
          case 3: heatmap.set("radius", radius * 8); break;
          case 2: heatmap.set("radius", radius * 4); break;
          case 1: heatmap.set("radius", radius * 2); break;
          case 0: heatmap.set("radius", radius); break;
          case -1: heatmap.set("radius", radius / 2); break;
          case -2: heatmap.set("radius", radius / 4); break;
          case -3: heatmap.set("radius", radius / 8); break;
          case -4: heatmap.set("radius", radius / 16); break;
          case -5: heatmap.set("radius", radius / 32); break;
          default: break;
        }
      });
    } else {
      google.maps.event.clearListeners(map, "zoom_changed");
      heatmap.set("radius", radius);
    }
  })
  );
  divRseult.appendChild(document.createElement('br'));

  let divAncho = document.createElement('div');
  divAncho.classList.add('boton-ancho');
  if (ancho) {
    divAncho.innerHTML = '<i class="material-icons rotado" id="flecha-ensanchar" title="Contraer">keyboard_arrow_right</i>';
  } else {
    divAncho.innerHTML = '<i class="material-icons" id="flecha-ensanchar" title="Desplegar">keyboard_arrow_right</i>';
  }
  divAncho.addEventListener("click", () => BotonAncho());

  let divAtras = createDivMap(
    ['boton-mapa', 'bottom-left2', 'boton-atras'],
    '<i class="material-icons icon-back" title="Atras">arrow_back</i>',
    BotonAtras);

  let divCalles = createDivMap(
    ['boton-mapa', 'bottom-left', 'boton-atras', 'tags-container'],
    '<i class="fas fa-monument boton-logo-icon" title="Puntos de interes"></i>',
    BotonStreet);

  let divSatelite = createDivMap(
    ['boton-mapa', 'bottom-left3', 'boton-atras', 'tags-container'],
    '<i class="fas fa-satellite boton-logo-icon" title="satelite"></i>',
    botonSatellite);

  let divHeat = createDivMap(
    ['boton-mapa', 'bottom-left4', 'boton-atras', 'tags-container'],
    '<i class="fas fa-thermometer-half boton-logo-icon" title="Ajuste de calor"></i>',
    heatAdjustment);

  definePopupClass();
  streets = true;
  map.addListener('center_changed', function () {
    try { popupOld.setMap(null) } catch (e) { }
  });

  let divContent = document.createElement('div');
  divContent.id = 'content';

  document.getElementById('map').appendChild(divAdmin);
  document.getElementById('map').appendChild(divRseult);
  // document.getElementById('map').appendChild(divCreatePolygon);
  document.getElementById('map').appendChild(divAtras);
  document.getElementById('map').appendChild(divCalles);
  document.getElementById('map').appendChild(divAncho);
  document.getElementById('map').appendChild(divSatelite);
  document.getElementById('map').appendChild(divHeat);
  document.getElementById('map').appendChild(divContent);
}

const createDivMap = (classes, innerHtml, onClick) => {
  const div = document.createElement('div');
  classes.forEach(c => div.classList.add(c));
  div.innerHTML = innerHtml
  div.addEventListener("click", () => onClick());
  return div;
}

// const createDivPolys = () => {
//   let divCreatePolygon = document.createElement('div');
//   ['globo-mapa', 'top-left-2', 'layers-icon-style'].forEach(c => divCreatePolygon.classList.add(c));

//   const divIconPolys = document.createElement('div');
//   divIconPolys.classList.add('margin-3')
//   divIconPolys.addEventListener('click', () => {
//     if (divIconPolys.classList.contains('color-green')) {
//       divIconPolys.classList.remove('color-green')
//       creatingPolys = false;
//       google.maps.event.removeListener(addPolygonListener);
//       document.getElementById('create-polygon-container').style.display = 'none';
//     } else {
//       divIconPolys.classList.add('color-green')
//       creatingPolys = true;
//       addPolygonListener = map.addListener('click', (e) => addPointToPolygon(e));
//       document.getElementById('create-polygon-container').style.display = 'block';
//     }
//   });
//   divIconPolys.innerHTML = '<i class="fas fa-draw-polygon" title="Hacer polígonos"></i>';
//   const divContentPolys = document.createElement('div');
//   divContentPolys.id = 'create-polygon-container';

//   const divPolyName = document.createElement('div');
//   ['div-poly-name'].forEach(c => divPolyName.classList.add(c));
//   const inputPolyName = document.createElement('input');
//   inputPolyName.placeholder = 'Nombre';
//   inputPolyName.value = actualPoly;
//   inputPolyName.addEventListener('change', (e) => {
//     actualPoly = e.target.value
//   });
//   ['input-poly-name', 'kml-input'].forEach(c => inputPolyName.classList.add(c));

//   const divActionsPolyName = document.createElement('div');
//   ['div-poly-name'].forEach(c => divActionsPolyName.classList.add(c));
//   divActionsPolyName.appendChild(addActionsToPolyName(['fas', 'fa-plus', 'action-poly-name'], 'Nuevo', () => { }));
//   divActionsPolyName.appendChild(addActionsToPolyName(['fas', 'fa-download', 'action-poly-name'], 'Traer info', downloadPolyInfo));
//   divPolyName.appendChild(inputPolyName);
//   divPolyName.appendChild(divActionsPolyName);


//   const tableContentPolys = document.createElement('table');
//   tableContentPolys.classList.add('create-polygon-table');
//   const tHeadContentPolys = document.createElement('thead');
//   const tBodyContentPolys = document.createElement('tbody');
//   tBodyContentPolys.id = 'body-table-points'
//   tBodyContentPolys.classList.add('tbody-polygon-table');

//   const trHeadCP = document.createElement('tr');
//   const thHeadCP1 = document.createElement('th');
//   thHeadCP1.innerText = 'Puntos';
//   const thHeadCP2 = document.createElement('th');
//   thHeadCP2.innerText = 'Acciones';

//   trHeadCP.appendChild(thHeadCP1);
//   trHeadCP.appendChild(thHeadCP2);
//   tHeadContentPolys.appendChild(trHeadCP);
//   tableContentPolys.appendChild(tHeadContentPolys);
//   tableContentPolys.appendChild(tBodyContentPolys);

//   divContentPolys.appendChild(divPolyName);
//   divContentPolys.appendChild(tableContentPolys);

//   divCreatePolygon.appendChild(divIconPolys);
//   divCreatePolygon.appendChild(divContentPolys);


//   return divCreatePolygon;
// }

// const downloadPolyInfo = () => {
//   const polygon = softPolygons.get(actualPoly);
//   if (polygon.length < 3) {
//     alert('Favor crear un polígono');
//   } else
//     sendPolygon(polygon);
// }

const addPointToPolygon = e => {
  if (actionSetEditPoin === 1) return;
  if (addedPointMarker) addedPointMarker.setMap(null);
  const polygon = softPolygons.get(actualPoly);
  if (actionSetEditPoin === 0) {
    polygon.splice(actionPosEditPoin, 1, { lat: e.latLng.lat(), lng: e.latLng.lng() })
  } else if (actionSetEditPoin === 2) {
    polygon.splice(++actionPosEditPoin, 0, { lat: e.latLng.lat(), lng: e.latLng.lng() })
  }
  softPolygons.set(actualPoly, polygon);
  plotPolys(actualPoly, 'green', true);
  displayTablePoints();
  document.getElementById('body-table-points').scroll(0, 24 * (actionPosEditPoin));
}

const createPointAction = (classes, action, pos) => {
  const i = document.createElement('i');
  classes.forEach(c => i.classList.add(c));
  if (actionSetEditPoin === action && actionPosEditPoin === pos) {
    if (action !== 1)
      i.classList.add('color-green');
  }
  i.addEventListener('click', () => setActions(pos, action));
  return i;
}

const displayTablePoints = () => {
  const polygon = softPolygons.get(actualPoly);

  const tBody = document.getElementById('body-table-points');
  tBody.innerHTML = '';

  polygon.forEach((p, i) => {
    const trBodyCP = document.createElement('tr');
    trBodyCP.addEventListener('mouseover', () => editMouseIn(i));
    trBodyCP.addEventListener('mouseout', () => editMouseOut());
    const tdBodyCP1 = document.createElement('td');
    tdBodyCP1.innerText = `${i + 1}`;

    const tdBodyCP2 = document.createElement('td');

    tdBodyCP2.appendChild(createPointAction(['fas', 'fa-pencil-alt'], 0, i));
    tdBodyCP2.appendChild(createPointAction(['far', 'fa-trash-alt'], 1, i));
    tdBodyCP2.appendChild(createPointAction(['fas', 'fa-plus'], 2, i));

    trBodyCP.appendChild(tdBodyCP1);
    trBodyCP.appendChild(tdBodyCP2);
    tBody.appendChild(trBodyCP);
  });
}

function setActions(pos, action) {
  if (addedPointMarker) addedPointMarker.setMap(null);
  editMouseOut();
  const polygon = softPolygons.get(actualPoly);
  actionSetEditPoin = action;
  if (action === 1) {
    polygon.splice(pos, 1)
    softPolygons.set(actualPoly, polygon);
    plotPolys(actualPoly, 'green', true);
    if (pos <= actionPosEditPoin) actionPosEditPoin--;
  } else {
    actionPosEditPoin = pos;
    if (action === 0) {
      addPointMarker(polygon[actionPosEditPoin], 'edit');
    } else if (action === 2) {
      addPointMarker(polygon[actionPosEditPoin], 'add');
    }
  }
  displayTablePoints();
}

const editMouseIn = (i) => {
  const softPoly = softPolygons.get(actualPoly);
  var icon = {
    path: google.maps.SymbolPath.CIRCLE,
    fillColor: 'green',
    fillOpacity: 1,
    strokeColor: 'green',
    strokeOpacity: 0,
    strokeWeight: 1,
    scale: 6
  }
  editPointMarker = new google.maps.Marker({
    position: softPoly[i],
    map: map,
    icon
  });
}

const editMouseOut = () => {
  editPointMarker.setMap(null);
}

const addPointMarker = (position, iconType) => {
  let iconPath = '';
  switch (iconType) {
    case 'edit': iconPath = 'M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z';
      break;
    case 'add': iconPath = 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z';
      break;
    default: iconPath = google.maps.SymbolPath.CIRCLE;
  }
  var icon = {
    path: iconPath,
    fillColor: 'green',
    fillOpacity: 0.5,
    strokeColor: 'green',
    strokeOpacity: 1,
    strokeWeight: 2,
    scale: 0.5
  }
  addedPointMarker = new google.maps.Marker({
    position,
    map: map,
    icon
  });
}

const plotPolys = (polyName, color, printDots = false) => {
  const actualPolyPloted = plotedPolygons.get(polyName);
  if (actualPolyPloted) actualPolyPloted.setMap(null);
  const softPoly = softPolygons.get(polyName);
  const polygon = new google.maps.Polygon({
    paths: softPoly,
    strokeColor: color,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: color,
    fillOpacity: 0.20,
  });
  google.maps.event.addListener(polygon, 'click', (e) => addPointToPolygon(e));
  polygon.setMap(map);
  plotedPolygons.set(polyName, polygon);
  if (!printDots) return;
  polyMarkers.forEach(m => m.setMap(null));
  polyMarkers = [];
  var icon = {
    path: google.maps.SymbolPath.CIRCLE,
    fillColor: color,
    fillOpacity: 0.5,
    strokeColor: color,
    strokeOpacity: 1,
    strokeWeight: 2,
    scale: 1
  }
  softPoly.forEach((val, i) => {
    const marker = new google.maps.Marker({
      position: val,
      map: map,
      icon
    });
    polyMarkers.push(marker)
    if (i === actionPosEditPoin && actionSetEditPoin === 2) {
      if (actionSetEditPoin) addPointMarker(val, 'add');
      else addPointMarker(val, 'edit');
    }
  });
}

// const addActionsToPolyName = (classes, title, func) => {
//   const actionDiv = document.createElement('div');
//   actionDiv.classList.add('action-div-i-container');
//   const action = document.createElement('i');
//   classes.forEach(c => action.classList.add(c));
//   action.title = title;
//   actionDiv.addEventListener('click', () => func())
//   actionDiv.appendChild(action);
//   return actionDiv;
// }

export const setPoint = (group, addedPointFunc) => {
  if (!map) setTimeout(() => setPoint(group, addedPointFunc), 100);
  else setPointOnMap(group, addedPointFunc);
}

const setPointOnMap = (group, addedPointFunc) => {
  grupo = group;
  onAddedPoint = addedPointFunc;
  addingPoint = true;
  addPointListener = map.addListener("click", addPoint);
}

const addPoint = (e) => {
  if (addedMarker) {
    addedMarker.setMap(null)
  } else {
    createAceptClosePoint();
    divMap = document.getElementById('map');
    resizeObserver = new ResizeObserver(() => mapResize('accept-cancel-add-bottons'));
    resizeObserver.observe(divMap);
    mapResize('accept-cancel-add-bottons');
  }
  addedMarker = new google.maps.Marker({
    position: e.latLng,
    map: map,
    icon: grupo.icon
  });
  addedPoint = { lat: e.latLng.lat(), lng: e.latLng.lng() }
}

export const deleteResize = () => {
  try {
    resizeObserver.unobserve(divMap)
  } catch (error) { }
}

const createAceptClosePoint = () => {
  let divChecks = document.createElement('div');
  divChecks.id = 'accept-cancel-add-bottons'
  divChecks.classList.add('bottons-checks');
  let divAccept = document.createElement('div');
  divAccept.classList.add('add-bottons-options');
  divAccept.classList.add('accept-botton');
  divAccept.innerHTML = '<i class="fas fa-check" title="Aceptar"></i>';
  divAccept.addEventListener("click", function () {
    if (addedMarker) {
      addedMarker.setMap(null)
      addedMarker = null;
      onAddedPoint(true, addedPoint)
      deleteResize();
      removeElement('accept-cancel-add-bottons')
      google.maps.event.removeListener(addPointListener);
    } else {
      window.alert('Seleccione un punto')
    }
  });
  let divCancel = document.createElement('div');
  divCancel.classList.add('add-bottons-options');
  divCancel.classList.add('cancel-botton');
  divCancel.innerHTML = '<i class="fas fa-times" title="Cancelar"></i>';
  divCancel.addEventListener("click", function () {
    if (addedMarker) {
      addedMarker.setMap(null)
      addedMarker = null;
    }
    onAddedPoint(false)
    deleteResize();
    removeElement('accept-cancel-add-bottons')
    google.maps.event.removeListener(addPointListener);
  });
  divChecks.appendChild(divAccept)
  divChecks.appendChild(divCancel)
  document.getElementById('map').appendChild(divChecks);
}

const mapResize = (id) => {
  const mapaBound = document.getElementById('map').getBoundingClientRect();
  const divTop = document.getElementById(id);
  const divBound = divTop.getBoundingClientRect();
  const widht = (mapaBound.width - divBound.width) / 2;
  divTop.style.left = widht + 'px';
}

const heatAdjustment = (open) => {
  if (!openHeatAdjustment) createHeatAdjustment();
  else {
    removeElement('slides-heat');
    deleteResize();
  }
  openHeatAdjustment = !openHeatAdjustment;
}

const createHeatAdjustment = () => {
  let divSlides = document.createElement('div');
  divSlides.id = 'slides-heat';
  divSlides.classList.add('slider-container');
  const divRadius = createSlide({
    title: 'Radio',
    min: 1,
    max: radius * 3,
    val: radius,
    step: 0.01,
    onInput: (e, text) => {
      radius = Number(e.target.value)
      heatmap.set('radius', radius);
      text.innerHTML = radius;
    }
  })
  const divDensity = createSlide({
    title: 'Intensidad',
    min: 1,
    max: intensity * 3,
    val: intensity,
    step: 0.01,
    onInput: (e, text) => {
      intensity = Number(e.target.value)
      heatmap.set('maxIntensity', intensity);
      text.innerHTML = intensity;
    }
  })
  const divOpacity = createSlide({
    title: 'Opacidad',
    min: 0,
    max: 100,
    val: opacity,
    step: 0.01,
    onInput: (e, text) => {
      opacity = Number(e.target.value)
      heatmap.set('opacity', opacity / 100);
      text.innerHTML = opacity;
    }
  })
  divSlides.appendChild(divRadius);
  divSlides.appendChild(divDensity);
  divSlides.appendChild(divOpacity);
  document.getElementById('map').appendChild(divSlides);

  divMap = document.getElementById('map');
  resizeObserver = new ResizeObserver(() => mapResize('slides-heat'));
  resizeObserver.observe(divMap);
  mapResize('slides-heat');
}

const createSlide = (ops) => {
  const divRadius = document.createElement('div');
  divRadius.classList.add('single-slider-container');
  const slideRadius = document.createElement('input');
  slideRadius.classList.add('slider-heat');
  slideRadius.type = 'range';
  slideRadius.min = ops.min;
  slideRadius.max = ops.max;
  const value = ops.val;
  slideRadius.value = value;
  slideRadius.step = ops.step;
  const labelRadius = document.createElement('label');
  labelRadius.innerText = ops.title;
  labelRadius.style.width = '70px';
  const valueRadius = document.createElement('label');
  valueRadius.style.width = '40px';
  valueRadius.innerText = value;
  slideRadius.oninput = (e) => ops.onInput(e, valueRadius);
  divRadius.appendChild(labelRadius);
  divRadius.appendChild(slideRadius);
  divRadius.appendChild(valueRadius);
  return divRadius;
}


export const insertPoints = (points) => {
  if (!map) setTimeout(() => insertPoints(points), 100);
  else insertPointsOnMap(points);
}

const insertPointsOnMap = (points) => {
  addingPoint = false;
  if (pointMarkersOnMap.length) {
    pointMarkersOnMap.forEach(p => p.setMap(null))
  }
  pointMarkersOnMap = points.filter(f => f.active).map(p => {
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(p),
      map: map,
      icon: p.icon
    });
    marker.addListener('click', function (e) {
      try { popupOld.setMap(null) } catch (e) { }
      var popup = new Popup(
        e.latLng,
        document.getElementById('content'),
        p,
        true
      );
      popup.setMap(map);
      popupOld = popup;
    });
    return marker;
  })
}


const removeElement = (id) => {
  try {
    const remove = document.getElementById(id);
    if (remove.parentNode) {
      remove.parentNode.removeChild(remove);
    }
  } catch (e) { }
}

export const setLayer = () => {
  const exist = document.getElementById('layers-container');
  if (!exist) setTimeout(() => setLayer(), 100);
  else setLayerOnDom();
}

function removeKmlLayers() {
  layers.forEach(l => l.setMap(null))
  layers = [];
}

const setLayerOnDom = () => {
  removeKmlLayers()
  removeElement('layers-container')
  createDivLayer(true, ['fas', 'fa-cog', 'loading', 'open-close-legend', 'layers-icon-style'], 'Cargando');
  let url = `/api/v1/dashboard/getKmlList`;
  sendService(url).then(res => {
    removeElement('layers-container')
    if (!answerOk(res, () => {
      createDivLayer(true, ['fas', 'fa-folder-plus', 'open-close-legend', 'layers-icon-style'], 'Sin capas disponibles');
    })) return
    const actives = res.response.filter(f => f.active)
    if (!actives.length) {
      createDivLayer(true, ['fas', 'fa-folder-plus', 'open-close-legend', 'layers-icon-style'], 'Sin capas disponibles');
      return;
    }
    createDivLayer();
    let iconLayers = document.createElement('i');
    ['fas', 'fa-layer-group', 'open-close-legend', 'layers-icon-style'].forEach(c => iconLayers.classList.add(c));
    iconLayers.setAttribute('title', 'Capas');
    let legend = document.createElement('div');
    ['display-none', 'legend-map-container-layers'].forEach(c => legend.classList.add(c));
    let divIcon = document.createElement('p')
    divIcon.classList.add('p-x')
    divIcon.appendChild(iconLayers)
    const divLayers = document.getElementById('layers-container')
    iconLayers.addEventListener('click', () => {
      if (divLayers.classList.contains('size-open-layers')) {
        divLayers.classList.remove('size-open-layers')
        legend.classList.add('display-none')
      } else {
        divLayers.classList.add('size-open-layers')
        setTimeout(() => {
          legend.classList.remove('display-none')
        }, 700)
      }
    });
    actives.forEach((l, i) => {
      const layer = new google.maps.KmlLayer(l.url, {
        preserveViewport: true, // suppressInfoWindows: true,
      });
      layers.push(layer)
      legend.appendChild(createCheckboxMap(l.name, false, `layer-${i}`, 0, () => {
        if (document.getElementById(`layer-${i}`).checked) layer.setMap(map);
        else layer.setMap(null);
      }));
      legend.appendChild(document.createElement('br'));
    })
    divLayers.appendChild(divIcon)
    divLayers.appendChild(legend)
  })
}


const createDivLayer = (noRet, classes, title) => {
  let divLayers = document.createElement('div');
  ['globo-mapa', 'top-right', 'size-close'].forEach(c => divLayers.classList.add(c))
  divLayers.id = 'layers-container'
  document.getElementById('map').appendChild(divLayers);
  if (!noRet) return
  let iconLayers = document.createElement('i');
  classes.forEach(c => iconLayers.classList.add(c))
  iconLayers.setAttribute('title', title)
  let divIcon = document.createElement('p')
  divIcon.classList.add('p-x')
  divIcon.appendChild(iconLayers)
  divLayers.appendChild(divIcon)
}

export const startMap = (opts) => {
  setLayer();
  setTimeout(() => {
    initMap(opts);
  }, 700);
}

export const setData = (data) => {
  try {
    let geoData = data.filter(item => {
      if (item.lat === null || item.lng === null) return false
      if (item.lat < 0 || item.lat > 15) return false
      if (item.lng < -100 || item.lng > -50) return false
      return true
    })
    createMarkers(geoData);
    createHeat(geoData);
    if (document.getElementById('casos').checked) showMarkers();
    else hideMarkers();

    if (document.getElementById('calor').checked) showHeat();
    else hideHeat();

  } catch (error) { }
}

function createMarkers(vector) {
  hideMarkers();
  markers = [];
  markers = vector.map((val, i) => {
    let marker = new google.maps.Marker({
      position: val,
      icon: getIconPath(val.fen ? val.fen : 'qr'),
    });

    marker.addListener('click', function () {
      try { popupOld.setMap(null) } catch (e) { }
      var popup = new Popup(
        new google.maps.LatLng(val),
        document.getElementById('content'),
        val
      );
      popup.setMap(map);
      popupOld = popup;
    });
    return marker
  });
}

function createHeat(vector) {
  hideHeat();
  let data =  vector.map((value) => new google.maps.LatLng(value));
  heatmap = new google.maps.visualization.HeatmapLayer({ data });
  intensity = data.length * 0.01;
  radius = 20;
  heatmap.set('maxIntensity', intensity);
  heatmap.set('radius', radius);
}

function hideMarkers() {
  markers.map((value, i) => {
    value.setMap(null);
    return null;
  });
}

function showMarkers() {
  markers.map((value, i) => {
    value.setMap(map);
    return null;
  });
}

function hideHeat() {
  try {
    heatmap.setMap(null);
  } catch (error) { }
}

function showHeat() {
  try {
    heatmap.setMap(map);
  } catch (error) { }
}

function createCheckboxMap(text, state, id, pxs, func) {
  let labelDivision = document.createElement('label');
  labelDivision.classList.add('label-checkbox');
  labelDivision.style.marginLeft = pxs + 'px';
  let inputDivision = document.createElement('input');
  inputDivision.type = 'checkbox';
  inputDivision.checked = state;
  inputDivision.id = id;
  inputDivision.addEventListener('change', () => func());
  labelDivision.appendChild(inputDivision);
  var spanDivision = document.createElement('span');
  spanDivision.innerText = text;
  labelDivision.appendChild(spanDivision);
  return labelDivision;
}

////// Defines the Popup class. 
function definePopupClass() {
  Popup = function (position, content, tooltip, pin = false) {
    this.position = position;

    content.classList.add('popup-bubble-content');

    var pixelOffset = document.createElement('div');
    pixelOffset.classList.add('popup-bubble-anchor');

    var title = document.createElement('p');
    title.classList.add('popup-bundle-title');
    let icon = tooltip.fen;
    if (!tooltip.fen) {
      icon = tooltip.catSecad;
    }
    if (pin) icon = tooltip.text + ' - ' + tooltip.createdAt.split('T')[0]
    icon = tooltip.qr ? tooltip.name : icon
    title.innerText = icon;
    var closeWindow = document.createElement('i');
    closeWindow.innerHTML = '<i class="popup-bundle-close material-icons">clear</i>';
    closeWindow.addEventListener('click', () => { try { popupOld.setMap(null) } catch (e) { } })
    title.appendChild(closeWindow);
    content.appendChild(title);

    console.log(tooltip)
    if (tooltip['citizenFiles.url']) {
      var photo = document.createElement('div');
      photo.classList.add('photo-content-ep');
      var image = document.createElement('img')
      image.alt = 'fotograía'
      image.src = tooltip['citizenFiles.url']
      image.classList.add('image-ep')
      photo.appendChild(image)
      content.appendChild(photo);
    }

    if (!pin) {
      var texts = document.createElement('div');
      texts.classList.add('popup-bubble-text');
      if (tooltip.qr) {

        texts.appendChild(insertTooltipData(`Barrio: ${tooltip.barrio}`));
        texts.appendChild(insertTooltipData(tooltip.direccion));
        texts.appendChild(insertTooltipData(tooltip.espacio + ' m2'));
        texts.appendChild(insertTooltipData(`Actividad: ${tooltip['refActividadProductiva.actPro']}`));
        texts.appendChild(insertTooltipData(`Motivo: ${tooltip['refRazonOcupacion.razOcu']}`));
        texts.appendChild(insertTooltipData(`Ventas diarias: ${tooltip.ventaDiaria}`));
        texts.appendChild(insertTooltipData(`Ventas mensuales: ${tooltip.ventaMensual}`));
      } else {

        if (tooltip.fen) {
          texts.appendChild(insertTooltipData(tooltip.desCon));
          texts.appendChild(insertTooltipData(tooltip.spoa));
          texts.appendChild(insertTooltipData(tooltip.gender));
          texts.appendChild(insertTooltipData(tooltip.barrio));
          texts.appendChild(insertTooltipData(viewDate(tooltip.fecha)));
          texts.appendChild(insertTooltipData(tooltip.modal));
          texts.appendChild(insertTooltipData(tooltip.arma));
        } else {
          texts.appendChild(insertTooltipData(tooltip.descAtendSecad));
          texts.appendChild(insertTooltipData(tooltip.catSecad));
          texts.appendChild(insertTooltipData(tooltip.itemSecad));
          texts.appendChild(insertTooltipData(tooltip.clasCierSecad));
          texts.appendChild(insertTooltipData(tooltip.barrio));
          // texts.appendChild(insertTooltipData(viewDate(tooltip.fecha)));
        }
      }
      content.appendChild(texts);
    }
    var map = document.createElement('div');
    map.id = 'mapStreetView';
    if (pin) map.classList.add('popup-bubble-map-pin-added')
    else map.classList.add('popup-bubble-map')

    content.appendChild(map);
    pixelOffset.appendChild(content);

    this.anchor = document.createElement('div');
    this.anchor.classList.add('popup-tip-anchor');
    this.anchor.appendChild(pixelOffset);

    // Optionally stop clicks, etc., from bubbling up to the map.
    this.stopEventPropagation();
  };


  // NOTE: google.maps.OverlayView is only defined once the Maps API has
  // loaded. That is why Popup is defined inside initMap().
  Popup.prototype = Object.create(google.maps.OverlayView.prototype);

  //// Called when the popup is added to the map.
  Popup.prototype.onAdd = function () {
    this.getPanes().floatPane.appendChild(this.anchor);
    new google.maps.StreetViewPanorama(
      document.getElementById('mapStreetView'), {
      position: this.position,
      pov: {
        heading: 270,
        pitch: 0
      },
      visible: true
    }
    );
  };

  //// Called when the popup is removed from the map. 
  Popup.prototype.onRemove = function () {
    if (this.anchor.parentElement) {
      this.anchor.parentElement.removeChild(this.anchor);
      let div = document.createElement('div');
      div.id = 'content';
      document.body.appendChild(div);
    }
  };

  ///// Called when the popup needs to draw itself. 
  Popup.prototype.draw = function () {
    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
    // Hide the popup when it is far out of view.
    var display =
      Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
        'block' :
        'none';

    if (display === 'block') {
      this.anchor.style.left = divPosition.x + 'px';
      this.anchor.style.top = divPosition.y + 'px';
    }
    if (this.anchor.style.display !== display) {
      this.anchor.style.display = display;
    }
  };

  //// Stops clicks/drags from bubbling up to the map. 
  Popup.prototype.stopEventPropagation = function () {
    var anchor = this.anchor;
    anchor.style.cursor = 'auto';

    ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
      'pointerdown']
      .forEach(function (event) {
        anchor.addEventListener(event, function (e) {
          e.stopPropagation();
        });
      });
  };
}

const viewDate = date => `${date.split('T')[0]} - ${date.split('T')[1].split('.')[0]}`

function insertTooltipData(propierty) {
  if (propierty !== undefined && propierty !== null) {
    var text = document.createElement('p');

    text.innerText = propierty;
    return text;
  } else {
    var span = document.createElement('span');
    return span;
  }
}

function getIconPath(icon) {
  switch (icon) {
    case 'qr': return 'https://app-recursos.s3.us-west-1.amazonaws.com/granada/images/Marcador-ep.png'
    case 'otro': return 'https://villavo-demo-rec.s3-us-west-1.amazonaws.com/map_icons/Points10px/BluePoint.png'
    default: return 'https://villavo-demo-rec.s3-us-west-1.amazonaws.com/map_icons/Points10px/OrangePoint.png'
  }
}

function HttpServiceCroquis(src) {
  var xhttpIcon = new XMLHttpRequest();
  xhttpIcon.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        var xmlString = this.response;
        var parser = new DOMParser();
        var comunas = parser.parseFromString(xmlString, "text/xml")
        var dataPolys = CreateDataForPolygon(comunas, false)
        polyCroquis = CreatePolygonLayer(dataPolys, { zIndex: 1, color: '#0e6fa5', fillOpacity: 0 });    //amarillo
        SetPolysInMap(polyCroquis);
        // setTimeout(() => {
        //   fitAllMap()
        // }, 1000)
      }
      else {
        console.error(this.responseText);
      }
    }
  };
  xhttpIcon.open("GET", src, true);
  xhttpIcon.send();
}

function HttpServiceCapa(src) {
  var xhttpIcon = new XMLHttpRequest();
  xhttpIcon.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        var xmlString = this.response;
        var parser = new DOMParser();
        var comunas = parser.parseFromString(xmlString, "text/xml")
        var dataPolys = CreateDataForPolygon(comunas, false)
        polyCapa = CreatePolygonLayer(dataPolys, { zIndex: 1, color: '#0e6fa5', fillOpacity: 0 });
      }
      else {
        console.error(this.responseText);
      }
    }
  };
  xhttpIcon.open("GET", src, true);
  xhttpIcon.send();
}

function fitAllMap(polys) {
  let bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < polys.length; i++) {
    bounds = getBounds(polys[i], bounds)
  }
  map.fitBounds(bounds);
}

function CreateDataForPolygon(doc, isCroquis = true) {
  let polygons = [];
  var places = doc.getElementsByTagName('Placemark');
  for (let i = 0; i < places.length; i++) {
    var coords = places[i].getElementsByTagName('coordinates');
    for (let j = 0; j < coords.length; j++) {
      polygons.push({
        polygon: GetCordsFromPlacemark(coords[j]),
        description: isCroquis ? 'shape' : GetDescFromPlacemark(places[i])
      })
    }
  }
  return polygons;
}

function getBounds(poly, bounds) {
  var latLngs = poly.getPath()
  for (var i = 0; i < latLngs.length; i++) {
    bounds.extend(latLngs.getAt(i));
  }
  return bounds
}

function GetDescFromPlacemark(place) {
  var desc = place.getElementsByTagName('SchemaData')[0].getElementsByTagName('SimpleData');
  var resp = {};
  for (let i = 0; i < desc.length; i++) {
    resp = {
      ...resp,
      [desc[i].getAttribute('name')]: desc[i].innerHTML
    }
  }
  return resp;
}

function GetCordsFromPlacemark(coords) {
  var coordsVec = coords.innerHTML.split(" ");
  var resp = [];
  for (let i = 0; i < coordsVec.length; i++) {
    let vec = coordsVec[i].split(',');
    if (!isNaN(Number(vec[1])))
      resp.push({ lng: Number(vec[0]), lat: Number(vec[1]) });
  }
  // let tales = CreatePolygonMap(resp, color, fillOpacity, description, zIndex)
  return resp
}

function CreatePolygonLayer(data, options = { zIndex: 1, color: '#fff', fillOpacity: '0' }) {
  var polygonsLayer = data.map(item => CreatePolygonMap(item.polygon, item.description, options))
  return polygonsLayer
}

function CreatePolygonMap(coords, description, options) {
  var poly = new google.maps.Polygon({
    paths: coords,
    strokeColor: options.color,
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: options.color,
    fillOpacity: options.fillOpacity,
    zIndex: options.zIndex,
    desc: description
  });
  google.maps.event.addListener(poly, 'click', function (event) {
    if (creatingPolys) {
      addPointToPolygon(event);
      return;
    }
    if (addingPoint) {
      addPoint(event)
    } else {
      console.log(description)
      if (description.CODIGO.length === 1) {
        fitBounds(poly)
        DeletePolysInMap(polyCroquis);
        indexActions.selectFilter({ id: parseInt(description.LOCALIDAD), value: description.NOMBRE }, 'comuna')
        const barrios = polyCapa.filter(p => p.desc.LOCALIDAD === description.LOCALIDAD)
        SetPolysInMap(barrios)
        comunaSelected = description.LOCALIDAD
        mapStep = 1
      } else {
        indexActions.selectFilter({ id: parseInt(description.CODIGO), value: description.NOMBRE }, 'barrio')
        DeletePolysInMap(polyCapa);
        poly.setMap(map)
        fitBounds(poly)
        mapStep = 2
      }
    }
  });
  google.maps.event.addListener(poly, 'mouseover', function (event) {
    if (creatingPolys) return;
    document.getElementById('mpio-text').innerText = description.NOMBRE
    poly.setOptions({ strokeWeight: 3 })
    if (description === 'shape')
      return
  });
  google.maps.event.addListener(poly, 'mouseout', function (event) {
    if (creatingPolys) return;
    document.getElementById('mpio-text').innerText = ''
    poly.setOptions({ strokeWeight: 1 })

    if (description === 'shape')
      return
  })
  return poly;
}

const DeleteLegend = () => {
  try {
    document.getElementById('map').removeChild(document.getElementById('legend-map'));
  } catch (e) { }
}

export const ClickPoligon = (object, id, zona) => {
  if (document.getElementById('cua').checked)
    return;
  DeleteLegend();
  DeletePolysInMap(capaActual);
  capaActual = [];
  // capaActual = CreatePolygonMap(polyBarrios, 'rgba(0,0,0,0)', funBarrio, zona, object, id);
  SetPolysInMap(capaActual);
  // FitBounds(capaActual);
  var ante = {
    object: 'rio',
    id: 0
  }
  switch (zona) {
    case 'com':
      ante.object = 'inicio';
      ante.id = 0;
      break;
    default:
      ante.object = object;
      ante.id = id;
      break;
  }
  mapaActual.push(ante);
}

function BotonAtras() {
  try {
    let polys = []
    if (mapStep === 1) polys = polyCroquis
    else if (mapStep === 2) polys = polyCapa.filter(p => p.desc.LOCALIDAD === comunaSelected)
    else return
    DeletePolysInMap(polyCapa);
    SetPolysInMap(polys)
    fitAllMap(polys)
    mapStep -= 1
  } catch (e) { }
}

function fitBounds(poly) {
  var latLngs = poly.getPath()
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0; i < latLngs.length; i++) {
    bounds.extend(latLngs.getAt(i));
  }
  map.fitBounds(bounds);
}

function SetPolysInMap(polygon) {
  for (let i = 0; i < polygon.length; i++) {
    polygon[i].setMap(map)
  }
}

function DeletePolysInMap(polygon) {
  try {
    for (let i = 0; i < polygon.length; i++) {
      polygon[i].setMap(null);
    }
  } catch (e) { }
}

export const selectComunas = (val) => {
  // actualComunas = val;
}

export const selectBarrios = (val) => {
  // actualBarrios = val; 
}

function BotonStreet() {
  if (streets) {
    map.setOptions({
      styles: []
    });
    streets = false;
  } else {
    map.setOptions({
      styles: styleRoad
    });
    streets = true;
  }
}

function botonSatellite() {
  if (satellite) map.setMapTypeId('roadmap');
  else map.setMapTypeId('hybrid');
  satellite = !satellite
}

var ancho = false;
function BotonAncho() {
  const $flecha = document.getElementById('flecha-ensanchar');
  const $filtro = document.getElementsByClassName('Filter')[0];
  const $results = document.getElementsByClassName('Results')[0];
  const ops = {
    duration: 400,
    easing: 'linear',
    fill: 'forwards',
  };
  if (ancho) {
    ancho = false;
    $flecha.animate([
      { transform: 'rotate(180deg)' },
      { transform: 'rotate(0deg)' }
    ], ops);
    $flecha.setAttribute('title', 'Desplegar');
  } else {
    ancho = true;
    $flecha.animate([
      { transform: 'rotate(0deg)' },
      { transform: 'rotate(180deg)' }
    ], ops);
    $flecha.setAttribute('title', 'Contraer');
  }
  funcFromMap(ancho);
}

var styleRoad = [
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
]
